import _extends from "@babel/runtime/helpers/esm/extends";
import { css as _css } from "@emotion/react";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import { keyframes } from '@emotion/react';
import clsx from 'clsx';
import { jsx as ___EmotionJSX } from "@emotion/react";
const loaderRotateKeyframes = keyframes({
  '100%': {
    transform: 'rotate(360deg)'
  }
});
const loaderCircleKeyframes = keyframes({
  '0%': {
    strokeDasharray: '1, 200',
    strokeDashoffset: 0
  },
  '50%': {
    strokeDasharray: '89, 200',
    strokeDashoffset: '-35px'
  },
  '100%': {
    strokeDasharray: '89, 200',
    strokeDashoffset: '-124px'
  }
});

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "19bf6hb",
  styles: "position:relative;width:1em;height:1em;display:inline-block;vertical-align:middle;&::before{content:'';display:block;padding-top:100%;}"
} : {
  name: "9egexv-Loader",
  styles: "position:relative;width:1em;height:1em;display:inline-block;vertical-align:middle;&::before{content:'';display:block;padding-top:100%;};label:Loader;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

const Loader = _ref => {
  let {
    className
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["className"]);

  return ___EmotionJSX("span", _extends({
    css: _ref2,
    className: clsx('CK__Loader', className)
  }, rest), ___EmotionJSX("svg", {
    css: /*#__PURE__*/_css({
      animation: `${loaderRotateKeyframes} 1.5s linear infinite`,
      height: '100%',
      transformOrigin: 'center center',
      width: '100%',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto'
    }, process.env.NODE_ENV === "production" ? "" : ";label:Loader;"),
    viewBox: "25 25 50 50"
  }, ___EmotionJSX("circle", {
    css: /*#__PURE__*/_css({
      strokeDasharray: '1, 200',
      strokeDashoffset: 0,
      animation: `${loaderCircleKeyframes} 1.5s ease-in-out infinite`,
      strokeLinecap: 'round',
      stroke: 'currentColor',
      fill: 'none',
      strokeWidth: 2
    }, process.env.NODE_ENV === "production" ? "" : ";label:Loader;"),
    cx: "50",
    cy: "50",
    r: "20",
    strokeMiterlimit: "10"
  })));
};

export default Loader;